export const RELEASE_HIGHLIGHT_QUERY_KEY = "release-highlights";
export const RELEASE_HIGHLIGHT_BEHEER_QUERY_KEY = "beheer-release-highlights";
